import React from "react";

const MainButton = ({ title, Icon, onClick }) => {
    return (
        <button onClick={onClick} className="text-white bg-indigo-600 px-8 py-2 rounded-lg transition-all duration-300 flex items-center gap-3">
            <span className="text-lg font-semibold">
                {title}
            </span>
            {Icon && <Icon className="text-current text-xl" />}
        </button>
    );
};

export default MainButton;
